import React from 'react';
import { Navigate } from 'react-router-dom';
import { PermissionRoute } from './PermissionRoute';

interface ProtectedRouteProps {
  authenticated: boolean;
  permission?: string;
  children: React.ReactElement;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  authenticated, 
  permission, 
  children 
}) => {
  if (!authenticated) {
    return <Navigate to="/login" />;
  }

  if (permission) {
    return (
      <PermissionRoute permission={permission}>
        {children}
      </PermissionRoute>
    );
  }

  return children;
};